import { createSelector } from 'reselect';
 
const selectSmsConfigurations = (state: any) => state.smsConfigurations;
 
export const selectSmsConfigurationsCurrentItem = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.current);
 
export const selectSmsConfigurationsListItems = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.list);
 
 
export const selectSmsConfigurationsItemById = (itemId: any) =>
    createSelector(selectSmsConfigurationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectSmsConfigurationsQueryItems = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.query);

export const selectSmsConfigurationsCreatedItem = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.create);
 
export const selectSmsConfigurationsUpdatedItem = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.update);
 
export const selectSmsConfigurationsReadItem = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.read);
 
export const selectSmsConfigurationsDeletedItem = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.delete);
 
export const selectSmsConfigurationsSearchedItems = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.search);
 
export const selectSmsConfigurationsItemsCount = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.count);
 
export const selectSmsConfigurationsItemsFilter = createSelector([selectSmsConfigurations], (smsConfigurations) => smsConfigurations.filter);